import React from 'react';
import Icon from 'components/Icon';

export const Navigation = ({
  onPreviousClick,
  onNextClick,
  label,
}: {
  onPreviousClick: (event: React.MouseEvent<any, MouseEvent>) => void;
  onNextClick: (event: React.MouseEvent<any, MouseEvent>) => void;
  label: string;
}) => (
  <>
    <div
      className="MultiImageFilePreviewModal-controls--button-previous"
      onClick={onPreviousClick}
      role="button"
      aria-label="previous"
      data-testid="multi-imagefile-preview-modal-controls-previous"
    >
      <Icon name="arrow-left" size="medium" />
    </div>
    <span className="MultiImageFilePreviewModal-controls--label">{label}</span>
    <div
      className="MultiImageFilePreviewModal-controls--button-next"
      onClick={onNextClick}
      role="button"
      aria-label="next"
      data-testid="multi-imagefile-preview-modal-controls-next"
    >
      <Icon name="arrow-left" size="medium" stroke-width="10" />
    </div>
  </>
);
